import React from "react";

/**
 * A skeleton loader for the product edit form. Adjust the layout as needed to match your actual form.
 */
export default function ProductFormSkeleton() {
  return (
    <div className="max-w-2xl mx-auto mt-4 p-6 bg-white border border-gray-100">
      {/* Hero image skeleton */}
      <div className="w-full flex justify-center mb-6 h-60">
        <div className="bg-gray-200 rounded-md h-64 w-[372px] relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-skeleton" />
        </div>
      </div>
      {/* Tabs skeleton */}
      <div className="flex mb-6">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="flex-1 h-8 mx-1 rounded bg-gray-200 relative overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-skeleton" />
          </div>
        ))}
      </div>
      {/* Form sections skeleton */}
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="mb-6">
          <div className="h-6 bg-gray-200 rounded w-1/2 mb-4 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-skeleton" />
          </div>
          <div className="space-y-5 justify-start">
            <div className="h-4 bg-gray-200 rounded w-3/5 mx-auto relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-skeleton" />
            </div>
            <div className="h-4 bg-gray-200 rounded w-2/3 mx-auto relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-skeleton" />
            </div>
          </div>
        </div>
      ))}
      {/* Highlights with image skeleton */}
      <div className="mb-6">
        <div className="h-6 bg-gray-200 rounded w-1/2 mb-4 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-skeleton" />
        </div>
        <div className="flex space-x-4">
          <div className="bg-gray-200 rounded-md h-32 w-32 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-skeleton" />
          </div>
          <div className="flex-1">
            <div className="h-4 bg-gray-200 rounded w-3/5 mb-2 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-skeleton" />
            </div>
            <div className="h-4 bg-gray-200 rounded w-2/3 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-skeleton" />
            </div>
          </div>
        </div>
      </div>
      {/* Documents panel skeleton */}
      <div className="mb-6">
        <div className="h-6 bg-gray-200 rounded w-1/2 mb-4 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-skeleton" />
        </div>
        <div className="space-y-5 justify-start">
          <div className="h-4 bg-gray-200 rounded w-3/5 mx-auto relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-skeleton" />
          </div>
          <div className="h-4 bg-gray-200 rounded w-2/3 mx-auto relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-skeleton" />
          </div>
        </div>
      </div>
      {/* Save button skeleton */}
      <div className="h-10 bg-gray-300 rounded w-40 mx-auto mt-8 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300 animate-skeleton" />
      </div>
      <style jsx>{`
        .animate-skeleton {
          animation: skeleton-loading 1.2s linear infinite;
        }
        @keyframes skeleton-loading {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </div>
  );
}
